//
//
//
//
//
//
//
//
//

import cookie from 'js-cookie'
import api_php from '@/api/api_php.js';

export default{
	data(){
		return{
			show:false
		}
	},
	created(){
		if(process.env.NODE_ENV != 'production'){
			this.show = true;
		};
	},
	methods:{
		del(){
			localStorage.removeItem('openId');
			cookie.remove('token');
			location.reload();
		}
	}
}



// WEBPACK FOOTER //
// ./src/App.vue